import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import DefaultFallback  from '@/_boundaries/DefaultFallback/DefaultFallback';
import PageLoadingSpinner from '@/_components/PageLoadingSpinner/PageLoadingSpinner';

const LanguageFormContainer = React.lazy(() => import('Login/containers/LanguageFormContainer'));

/**
 * Renders the language selection flow during login when multiple languages are available and none has been selected.
 *
 * Wraps the LanguageFormContainer in an ErrorBoundary and Suspense fallback to provide loading and error handling.
 */
const LanguagePicker = () => {
  return (
    <ErrorBoundary FallbackComponent={DefaultFallback}>
      <React.Suspense fallback={<PageLoadingSpinner label="Loading language options" />}>
        <LanguageFormContainer />
      </React.Suspense>
    </ErrorBoundary>
  );
}

export default LanguagePicker;